import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { EmailTemplatedMessagesType } from '@/types/templated-messages'
import { getEmailTemplatedMessage } from '@/lib/api/templated-messages'
import { Button } from '@/components/ui/button'
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza'
import {
  DialogClose,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog'
import EditTemplatedMessagesForm from '@/components/forms/edit-templated-messages-form'

export const Route = createFileRoute('/_home/message-templates/email/edit')({
  component: EditEmailTemplatedMessagesPage,
})

export default function EditEmailTemplatedMessagesPage({
  emailTemplatedMessage,
  setShowEditEmailTemplatedModal,
}: {
  emailTemplatedMessage: EmailTemplatedMessagesType
  setShowEditEmailTemplatedModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <main>
      {/*   <DialogContent className="md:max-w-[850px]">
        <EditTemplatedMessagesForm
          emailTemplatedMessage={emailTemplatedMessage}
        />
        <DialogFooter className="flex flex-row justify-end gap-2 md:mr-4">
          <DialogClose>
            <Button variant="outline" type="submit" className="w-28">
              Cancel
            </Button>
          </DialogClose>
          <Button type="submit" className="w-28">
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent> */}

      <CredenzaContent className="flex w-full max-w-[750px] justify-center">
        <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
          <EditTemplatedMessagesForm
            emailTemplatedMessage={emailTemplatedMessage}
            setShowEditEmailTemplatedModal={setShowEditEmailTemplatedModal}
          />
        </CredenzaBody>
      </CredenzaContent>
    </main>
  )
}
